import { container } from '@graphistry/falcor-react-redux';
import { Histogram } from '../histograms';
import mapPropsStream from 'react-recompose/mapPropsStream';
import createEventHandler from 'react-recompose/createEventHandler';

//TODO allow user to set legend dimensions
export const withLegendContainer = container({
    renderLoading: true,
    //FIXME: type/pivotHistogram iif visible && in columns
    fragment: (legend = {}) => `{
            visible,
            activeTab,
            encodings: {
                point: { color, size, icon },
                edge: { color, icon }
            },
            columns: {
                length, [0...${(legend.columns || []).length || 0}]: {
                    name, componentType
                }
            },
            ${!legend.visible ? `` :
           `typeHistogram: ${Histogram.fragment(legend.typeHistogram)},
            pivotHistogram: ${Histogram.fragment(legend.pivotHistogram)}`}
        }`,
    mapFragment(data, props, $falcor) {
        return { ...data, $falcor };
    }
});

export const legendTabInteractions = mapPropsStream(propStream => {
    const { stream: selectedTabs, handler: onTabSelected } = createEventHandler();
    return propStream
        .switchMap(({ $falcor, ...props }) =>
            selectedTabs
                .switchMap(
                    activeTab => $falcor.set({ json: { activeTab } }).toPromise(),
                    (activeTab, { json }) => ({ ...props, ...json })
                )
                .startWith(props)
        )
        .map(props => ({ ...props, onTabSelected }));
});
